/** 效果基类(方案 G2/D 通用三段式)。每卡继承此,复刻 RainEffect 结构。 */
import { Container } from 'pixi.js';
import { scene } from '../engine/Scene';
import type { Layers } from '../engine/Stage';

export type EffectGroup = 'weather' | 'sky' | 'ceremony';

export interface OracleEffect {
  id: string;
  exclusiveGroup?: EffectGroup;
  done: boolean;
  start(k: number, durSec: number, meta?: any): void;
  update(dt: number): void;
  resolve(): void;
  destroy(): void;
}

export abstract class BaseEffect implements OracleEffect {
  id = '';
  exclusiveGroup?: EffectGroup;
  done = false;
  protected t = 0;
  protected k = 0.6;
  protected dur = 15;
  protected tail = 6;                 // 收尾时长
  protected layerName: keyof Layers = 'eventFX';
  protected g = new Container();
  protected resolving = false;

  start(k: number, durSec: number, meta?: any) {
    this.k = k; this.dur = durSec;
    scene.stage.layers[this.layerName].addChild(this.g);
    this.onStart(meta);
  }
  update(dt: number) {
    this.t += dt;
    this.onUpdate(dt);
    if (this.t >= this.dur + this.tail) this.done = true;
  }
  resolve() {
    if (this.resolving) return;
    this.resolving = true;
    this.dur = Math.min(this.dur, this.t);   // 立刻进入收尾
    this.onResolve();
  }
  destroy() {
    this.g.destroy({ children: true });
    this.onDestroy();
  }

  /** 三段包络:前奏 0→1(inSec) → 平台 → 收尾 1→0(tail) */
  protected env(inSec = 1): number {
    if (this.t < inSec) return this.t / inSec;
    if (this.t > this.dur) return Math.max(0, 1 - (this.t - this.dur) / this.tail);
    return 1;
  }
  protected get stage() { return scene.stage; }
  protected get crowd() { return scene.crowd; }
  protected get island() { return scene.island; }

  abstract onStart(meta?: any): void;
  abstract onUpdate(dt: number): void;
  onResolve(): void {}
  onDestroy(): void {}
}
